import { gql } from '@apollo/client'

const OPERATION_CREATE_RAN_ROOM = gql`
  mutation createRanRoom($sf_id: String!, $name: String!, $description: String!, $pre_shared_keys: PreSharedKeysInput) {
    room: createRanRoom(
      sf_id: $sf_id
      room: { name: $name, description: $description }
      pre_shared_keys: $pre_shared_keys
    ) {
      id
      name
      description
      wifi_psk
      ssid_id
      ssid_name
      vlan
      created_at
    }
  }
`
export const OPERATION_IMPORT_RAN_ROOMS = gql`
  mutation importRanRooms($sf_id: String!, $rows: JSON!, $ssid_id: ID) {
    result: importRanRooms(sf_id: $sf_id, rows: $rows, ssid_id: $ssid_id) {
      rooms {
        id
        name
        description
        wifi_psk
        ssid_id
        ssid_name
        vlan
        created_at
      }
      errors
    }
  }
`
export const OPERATION_UPDATE_RAN_ROOM = gql`
  mutation updateRanRoom(
    $sf_id: String!
    $room_id: Int!
    $name: String!
    $description: String!
    $pre_shared_keys: PreSharedKeysInput
  ) {
    room: updateRanRoom(
      sf_id: $sf_id
      room_id: $room_id
      room: { name: $name, description: $description }
      pre_shared_keys: $pre_shared_keys
    ) {
      id
      name
      description
      wifi_psk
      ssid_id
      ssid_name
      vlan
      created_at
    }
  }
`

export const OPERATION_DELETE_RAN_ROOM = gql`
  mutation deleteRanRoom($sf_id: String!, $room_id: Int!) {
    room: deleteRanRoom(sf_id: $sf_id, room_id: $room_id) {
      id
    }
  }
`

export const OPERATION_RESET_RAN_ROOM = gql`
  mutation resetRanRoom($sf_id: String!, $room_id: Int!) {
    room: resetRanRoom(sf_id: $sf_id, room_id: $room_id) {
      id
      wifi_psk
    }
  }
`

export default OPERATION_CREATE_RAN_ROOM
